function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import { createNode } from '../doc/createNode.js';
import { stringifyPair } from '../stringify/stringifyPair.js';
import { addPairToJSMap } from './addPairToJSMap.js';
import { NODE_TYPE, PAIR, isNode } from './identity.js';

function createPair(key, value, ctx) {
  var k = createNode(key, undefined, ctx);
  var v = createNode(value, undefined, ctx);
  return new Pair(k, v);
}

var Pair = /*#__PURE__*/function () {
  function Pair(key) {
    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    _classCallCheck(this, Pair);

    Object.defineProperty(this, NODE_TYPE, {
      value: PAIR
    });
    this.key = key;
    this.value = value;
  }

  _createClass(Pair, [{
    key: "clone",
    value: function clone(schema) {
      var key = this.key,
          value = this.value;
      if (isNode(key)) key = key.clone(schema);
      if (isNode(value)) value = value.clone(schema);
      return new Pair(key, value);
    }
  }, {
    key: "toJSON",
    value: function toJSON(_, ctx) {
      var pair = ctx !== null && ctx !== void 0 && ctx.mapAsMap ? new Map() : {};
      return addPairToJSMap(ctx, pair, this);
    }
  }, {
    key: "toString",
    value: function toString(ctx, onComment, onChompKeep) {
      return ctx !== null && ctx !== void 0 && ctx.doc ? stringifyPair(this, ctx, onComment, onChompKeep) : JSON.stringify(this);
    }
  }]);

  return Pair;
}();

export { Pair, createPair };